import Image from "next/image";
import Link from "next/link";

/*import "./PostCardImg.scss";*/

const PostCardImg = ({
  post: { featuredImage, link },
  priority,
}: {
  post: {
    featuredImage?: {
      url: string;
    };
    link: string;
  };
  priority?: boolean;
}) => (
  <Link className="card-img" href={link}>
    {featuredImage && (
      <span className="card-img__media">
        <Image
          src={featuredImage.url}
          alt="Featured"
          width={0}
          height={0}
          sizes="100vw"
          unoptimized
          priority={priority}
          loading={priority ? "eager" : undefined}
        />
      </span>
    )}
  </Link>
);

export default PostCardImg;
